export enum QueryKeys {
  AccessTokens = 'access-tokens',
  Account = 'account',
  AccountBalance = 'account-balance',
  AccountGroups = 'account-groups',
  AccountStatements = 'account-statements',
  Accounts = 'accounts',
  Actors = 'actors',
  AdditionalFields = 'additional-fields',
  Addresses = 'addresses',
  AnnualReports = 'annual-reports',
  AnnualReportsCredits = 'annual-reports-credits',
  Attachment = 'attachment',
  AttachmentsCount = 'attachments-count',
  AttachmentsFiles = 'attachments-files',
  AttachmentsList = 'attachments-list',
  AttachmentsModal = 'attachments-modal',
  AttachmentZipDownloadPolling = 'attachment-zip-download-polling',
  BalanceModifiers = 'balance-modifiers',
  BalanceSheet = 'balance-sheet',
  BalanceSheetLegacy = 'balance-sheet-legacy',
  BookkeepingBankAccounts = 'bookkeeping-bank-accounts',
  BankAccounts = 'bank-accounts',
  BankPayment = 'bank-payment',
  BankAccountsPolling = 'bank-accounts-polling',
  BankBalance = 'bank-balance',
  BankLineMatchAssociations = 'bank-line-match-associations',
  BankLineMatchLines = 'bank-line-match-lines',
  BankLineMatchedItems = 'bank-line-matched-items',
  BankLineMatches = 'bank-line-matches',
  BankLines = 'bank-lines',
  BankLineSuggestions = 'bank-line-suggestions',
  Banks = 'banks',
  BanksList = 'banks-list',
  Bill = 'bill',
  BillReconciliationMatches = 'bill-reconciliation-matches',
  BillSubjectAssociations = 'bill-subject-associations',
  BillTimeline = 'bill-timeline',
  Bills = 'bills',
  BillsSummary = 'bills-summary',
  BohrScanResult = 'bohr-scan-result',
  Bookkeepers = 'bookkeepers',
  BookkeepingCategories = 'bookkeeping-categories',
  BookkeepingCategorySuggestions = 'bookkeeping-category-suggestions',
  BookkeepingTag = 'bookkeeping-tag',
  Cards = 'cards',
  ContactBalancePayment = 'contact-balance-payment',
  ContactBalancePostings = 'contact-balance-postings',
  ConversionBalance = 'conversion-balance',
  ClientInvoicesZervant = 'client-invoices-zervant',
  ClientQuotes = 'client-quotes',
  Companies = 'companies',
  Company = 'company',
  CompanyOnboarding = 'company-onboarding',
  Contact = 'contact',
  ContactBalance = 'contact-balance',
  ContactPersons = 'contact-persons',
  Contacts = 'contacts',
  ContactsAndContactPersons = 'contacts-and-contact-persons',
  Countries = 'countries',
  CreditorBalanceStatement = 'creditor-balance-statement',
  CreditorBalanceSummary = 'creditor-balance-summary',
  CreditorBalanceSummaryAccounts = 'creditor-balance-summary-accounts',
  Creditors = 'creditors',
  Currencies = 'currencies',
  CurrentUser = 'current-user',
  DaybookConsequences = 'daybook-consequences',
  DaybookTransaction = 'daybook-transaction',
  DebtCollectionTerms = 'debt-collection-terms',
  DebtorBalanceStatement = 'debtor-balance-statement',
  DebtorBalanceSummary = 'debtor-balance-summary',
  DebtorBalanceSummaryAccounts = 'debtor-balance-summary-accounts',
  Debtors = 'debtors',
  DebugBookkeepingCategories = 'debug-bookkeeping-categories',
  DeliveryNotes = 'delivery-notes',
  DmsDocument = 'dms-document',
  DmsFolderContents = 'dms-folder-contents',
  DmsFolders = 'dms-folders',
  DocumentReportsSalesOverview = 'document-reports-sales-overview',
  DocumentReportsSalesByItem = 'document-reports-sales-by-item',
  DocumentReportsSalesByCustomer = 'document-reports-sales-by-customer',
  EasyNumbers = 'easy-numbers',
  EInvoicingAddressSchemeTypeList = 'e-invoicing-address-scheme-type-list',
  EInvoicingConfirmCerfaLinkOnSign = 'e-invoicing-confirm-cerfa-link-on-sign',
  EInvoicingCreateKYC = 'e-invoicing-create-kyc',
  EInvoicingGetCerfaSignatureLink = 'e-invoicing-get-signature-link',
  EInvoicingGetIntegrationPdp = 'e-invoicing-get-integration-pdp',
  EInvoicingGetKYCStatus = 'e-invoicing-get-kyc-status',
  EInvoicingGetUploadURL = 'e-invoicing-get-upload-url',
  EInvoicingSirenAddressingLines = 'e-invoicing-siren-addressing-lines',
  File = 'file',
  EInvoicingCreateKYCDocument = 'e-invoicing-upload-kyc-file',
  EInvoicingDisabling = 'e-invoicing-disabling',
  EInvoicingLifecycleReasons = 'e-invoicing-lifecycle-reasons',
  ExpertBalanceSheet = 'expert-balance-sheet',
  ExpertProfitAndLoss = 'expert-profit-and-loss',
  ExpertTrialBalance = 'expert-trial-balance',
  ExternalInvoice = 'external-invoice',
  ExternalInvoices = 'external-invoices',
  ExternalInvoiceNumberingSequences = 'external-invoice-numbering-sequences',
  ExternalInvoicesSummary = 'external-invoices-summary',
  ExternalInvoicesSync = 'external-invoices-sync',
  ExternalUnrecognizedVatRates = 'external-unrecognized-vat-rates',
  FecAccountMappings = 'fec-account-mappings',
  FecImports = 'fec-imports',
  FecJournalMappings = 'fec-journal-mappings',
  FecThirdPartyMappings = 'fec-third-party-mappings',
  GlobalSearch = 'global-search',
  ImportedInvoice = 'imported-invoice',
  ImportedInvoices = 'imported-invoices',
  IncomeStatements = 'income-statements',
  IncomeTimeline = 'income-timeline',
  IntercomArticles = 'intercom-articles',
  Invoice = 'invoice',
  InvoiceLateFee = 'invoice-late-fee',
  InvoiceLogs = 'invoiceLogs',
  InvoiceReconciliationMatches = 'invoice-reconciliation-matches',
  InvoiceSnapshot = 'invoiceSnapshot',
  InvoiceSubjectAssociations = 'invoice-subject-associations',
  InvoiceTemplates = 'invoice-templates',
  InvoiceZervant = 'invoice-zervant',
  InvoiceZervantEmailTemplate = 'invoice-zervant-email-template',
  InvoiceZervantHtml = 'invoice-zervant-html',
  Invoices = 'invoices',
  InvoicesSummary = 'invoices-summary',
  InvoicesZervant = 'invoices-zervant',
  IsTrustedPartner = 'is-trusted-partner',
  Journals = 'journals',
  LogSearchCategory = 'log-search-category',
  MeasurementUnits = 'measurement-units',
  NextAvailableAccountNumber = 'next-available-account-number',
  NextQuoteNumber = 'next-quote-number',
  NextVoucherNo = 'next-voucher-no',
  OpenBankingAccounts = 'open-banking-accounts',
  Organization = 'organization',
  OrganizationBookkeepers = 'organization-bookkeepers',
  OrganizationFeatureFlags = 'organization-feature-flags',
  OrganizationImage = 'organization-image',
  OrganizationInvitation = 'organization-invitation',
  OrganizationOwners = 'organization-owners',
  OrganizationRoles = 'organization-roles',
  OrganizationSettingsUsersMembers = 'organization-settings-users-members',
  OrganizationSubscription = 'organization-subscription',
  OrganizationSubscriptionInfo = 'organization-subscription-info',
  OrganizationUsers = 'organization-users',
  PaymentMethod = 'payment-method',
  PaymentMethods = 'payment-methods',
  PaymentRemindersSettings = 'payment-reminder-settings',
  PayNowStatus = 'paynow-status',
  PeppolVerification = 'peppol-verification',
  Postings = 'postings',
  ProductPlans = 'product-plans',
  Products = 'products',
  ProfitAndLoss = 'profit-and-loss',
  PublicAccounts = 'public-accounts',
  Quote = 'quote',
  QuoteHtml = 'quote-html',
  Quotes = 'quotes',
  QuotesSummary = 'quotes-summary',
  RecurringInvoice = 'recurring-invoice',
  RecurringInvoiceDraftFormat = 'recurring-invoice-draft-format',
  RecurringInvoices = 'recurring-invoices',
  RecurringInvoicesSpawnSettings = 'recurring-invoices-spawn-settings',
  RecurringInvoicesSummary = 'recurring-invoices-summary',
  ReviewEntries = 'review-entries',
  ReviewEntryDetail = 'review-entry-detail',
  RegisteredForEInvoicing = 'registered-for-einvoicing',
  RequestAccountant = 'request-accountant',
  SalaryConnectionStatus = 'salary-connection-status',
  SalaryPayrolls = 'salary-payrolls',
  SalaryStatistics = 'salary-statistics',
  SalesDocumentDraft = 'sales-document-draft',
  SalesTaxPeriods = 'sales-tax-periods',
  SalesTaxRulesets = 'sales-tax-rulesets',
  SalesVatRatesWithRules = 'sales-vat-rates-with-rules',
  SalesWithoutVat = 'sales-without-vat',
  ScoutConnections = 'scout-connections',
  SelectableProductAccounts = 'selectable-product-accounts',
  SkatConnection = 'skat-connection',
  StandardInvoiceTemplate = 'standard-invoice-template',
  SubscriptionInvoicePdf = 'subscription-invoice-pdf',
  SubscriptionInvoices = 'subscription-invoices',
  SubscriptionMetrics = 'subscription-metrics',
  SubscriptionPlans = 'subscription-plans',
  Tasks = 'tasks',
  TaxationTypeSettings = 'taxation-type-settings',
  TaxRates = 'tax-rates',
  TaxReturnPeriods = 'tax-return-periods',
  TokenInfo = 'token-info',
  TopCustomers = 'top-customers',
  TopSuppliers = 'top-suppliers',
  Transaction = 'transaction',
  Transactions = 'transactions',
  TrialBalance = 'trial-balance',
  TrialBalanceLegacy = 'trial-balance-legacy',
  Umbrella = 'umbrella',
  UmbrellaInvitation = 'umbrella-invitation',
  UmbrellaInvitedUsers = 'umbrella-invited-users',
  UmbrellaInvoices = 'umbrella-invoices',
  UmbrellaLicensePacks = 'umbrella-license-packs',
  UmbrellaLogo = 'umbrella-logo',
  UmbrellaMembers = 'umbrella-members',
  UmbrellaOrganizations = 'umbrella-organizations',
  UmbrellaOrganizationsInvitations = 'umbrella-organizations-invitations',
  UmbrellaOrganizationsProductPlans = 'umbrella-organizations-product-plans',
  UmbrellaOrganizationsSubscriptions = 'umbrella-organizations-subscriptions',
  UmbrellaOrganizationsVoucherStats = 'umbrella-organizations-voucher-stats',
  UmbrellaPaymentMethod = 'umbrella-payment-method',
  UmbrellaRoles = 'umbrella-roles',
  UmbrellaSubscriptions = 'umbrella-subscriptions',
  User = 'user',
  UserNotificationSettings = 'user-notification-settings',
  UserOrganization = 'user-organization',
  UserOrganizationMembership = 'user-organization-membership',
  UserOrganizationSetting = 'user-organization-setting',
  UserOrganizationSettings = 'user-organization-settings',
  UserOrganizations = 'user-organizations',
  UserProfilePic = 'user-profile-pic',
  ValidateAccountNumber = 'validate-account-number',
  VatAccounts = 'vat-accounts',
  VatDeclarationAuditTrail = 'vat-declaration-audit-trail',
  VatDeclarationPeriods = 'vat-declaration-periods',
  VatDeclarationSubmission = 'vat-declaration-submission',
  VatDeclarations = 'vat-declarations',
  VatDeclarationsPayments = 'vat-declarations-payments',
  VatPayment = 'vat-payment',
  VatRateTemplate = 'vat-rate-template',
  VatRatesRulesets = 'vat-rates-rulesets',
  VatRatesTemplates = 'vat-rates-templates',
  VatSuggestions = 'vat-suggestions',
  Voucher = 'voucher',
  VouchersList = 'vouchers-list',
  ZervantCompany = 'zervant-company',
  ZervantDocumentTemplateSettings = 'zervant-document-template-settings',
  ZervantInvoiceLogo = 'zervant-invoice-logo',
  ZervantSettings = 'zervant-settings',
  ZervantPortal = 'zervant-portal',
  ZervantSubscription = 'zervant-subscription',
}
